/* eslint-disable indent */
import {
  GET_MY_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_CONFIG,
  SUBSCRIBE_CREATE,
  GET_MY_SUBSCRIPTIONS_STATUS,
  GET_PENDING_PLACEMENT_FEES,
} from "../actionTypes";

const initialState = {
  states: [],
  isActive: false,
  availableSubsreiptions: null,
  mySubscriptions: null,
  pendingPlacementFees: {
    results: [],
    total: 0,
    per_page: 10,
    current_page: 1
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SUBSCRIPTIONS_CONFIG:
      return {
        ...state,
        availableSubsreiptions: payload,
      };

    case GET_MY_SUBSCRIPTIONS_STATUS:
      return {
        ...state,
        isActive: true,
      };
    case SUBSCRIBE_CREATE:
      return {
        ...state,
        subscription: payload,
      };
    case GET_MY_SUBSCRIPTIONS:
      return {
        ...state,
        mySubscriptions: payload,
      };
    case GET_PENDING_PLACEMENT_FEES:
      return {
        ...state,
        pendingPlacementFees: payload,
      };
    default:
      return state;
  }
};
